<div class="app-header">
  <div  class="banner">
    <div
      [ngStyle]="{
        'background-image':
          banner_image != undefined ? 'url(' + banner_image + ')' : 'none'
      }"
      class="banner__bg"
    >
      <ng-container  *ngIf="customTemplate === false; else custom">
        <div class="banner__content">
          <div class="banner__content__second" *ngIf="logo === true">
            <ng-content select=".banner__content__second__logo"></ng-content>
          </div>
          <div class="banner__content__main">
            <h2 class="banner__content__pretitle">
              <ng-content select=".pretitle"></ng-content>{{ pretitle | transloco }}
            </h2>
            <h1 class="banner__content__title" *ngIf="title != undefined">
              {{ title | transloco }}
            </h1>
              <div @heightAnimation *ngIf="customTitleSet" >
              <ng-content  select=".title"></ng-content>
            </div>
            <div class="banner__content__downtitle h1">{{downtitle | transloco}}
              <ng-content select=".downtitle_behind"></ng-content>

            </div>
          </div>
        </div>
        <div class="banner__nav"><ng-content></ng-content></div>
      </ng-container>
      <ng-template #custom>
        <div class="banner__content">
          <ng-content select=".banner__content"></ng-content>
        </div>
        <div class="banner__nav">
          <ng-content select=".banner__nav"></ng-content>
        </div>
      </ng-template>
    </div>
  </div>
</div>
